import app from './app'
import drivers from './drivers'
import session from './session'
import trips from './trips'
import vehicles from './vehicles'

export default { app, drivers, session, trips, vehicles }
